import React, { Component } from 'react';
import Actions from './../../Actions/Actions';
import {Row, Col,Collapse} from 'reactstrap';
import Steps from '../../../../Steps/Steps';
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import { manualDataEntrySteps, mapType } from './../../../../../utils/constants';
import { getKpiNameByCode,questionsBusinessCulture,questionsProcessAndPolicies,
  questionsBoard,questionsEmployeeLifecycle } from './../../../../../utils/manualEntryQuestions';
import ReviewAlert from './../ReviewAlert/ReviewAlert';

class ReviewManualDataEntry extends Component {

  state = {collapse : [false,false,false]}

  getAnsweredQuestionsCount = (grouped,key) => {
    if(key === 'Processes & Policies') {
      if(grouped[key]) {
        return Object.keys(groupBy(grouped[key].filter(o => o.value && o.value.length > 0),(o) => o.kpi)).length;
      } else {
        return 0;
      }
    } else {
      if(grouped[key]) {
        return grouped[key].filter(o => o.value && o.value.length > 0).length;
      } else {
        return 0;
      }
    }  
    // else {
      // console.log(grouped);
    //   let count = 0;
    //   if(grouped['Board']) {
    //     count += grouped['Board'].filter(o => o.value && o.value.length > 0).length;
    //   } 
    //   if(grouped['Employee Lifecycle']) {
    //     count += grouped['Employee Lifecycle'].filter(o => o.value && o.value.length > 0).length;
    //   }
    //   return count;
    // }
     
  }

  getTotalQuestionsCount = (key) => {
    if(key === 'Processes & Policies') {
      return Object.keys(groupBy(questionsProcessAndPolicies,(o) => o.kpiId)).length;
    } else if(key === 'Business & Culture') {
      return questionsBusinessCulture.length;
    } else if(key === 'Employee Lifecycle'){
      return questionsEmployeeLifecycle.length;
    } else if(key === 'Board'){
      return questionsBoard.length;
    }
    // else {
    //   const l = questionsBoard.concat(questionsEmployeeLifecycle);
    //   return l.length;
    // }
    
  }

  handleDropdownClick = (k) => {
    const {collapse} = this.state;
    collapse[k] = !collapse[k];
    this.setState({
      collapse : collapse
    });
  }

  populateDropdowns = () => {
    const {questionsWithAnswer} = this.props;
    const {collapse} = this.state;
    const grouped = groupBy(questionsWithAnswer,(o) => o.category);
    const dropdowns = [];
    const dropdownHeadings = [
      'Employee Lifecycle',      
      'Business & Culture',
      'Processes & Policies',
      'Board'
    ];
    // console.log(grouped);
    for(let k = 0 ; k < 4 ; k++) {
      const key = dropdownHeadings[k];
      // let growthAndOther = [];
      // console.log('groupedBoard', grouped['Board']);
      // if(grouped['Board']) {
      //   growthAndOther = grouped['Board'];
      // }
      // if(grouped['Employee Lifecycle']) {
      //   growthAndOther = growthAndOther.concat(grouped['Employee Lifecycle']);
      // }
      const dropdown = 
      <div key={k} className="review-sub-section row cursor-pointer" 
        onClick={() => this.handleDropdownClick(k)}>
        <div className="questions-row-title col-md-6 col-lg-6">
          {key}
        </div>
        <div className="review-answers-help-text col-md-5 col-lg-5">
          Answered questions for 
          <span className="ml5">{this.getAnsweredQuestionsCount(grouped,key)} </span>
            of {this.getTotalQuestionsCount(key)} KPIs 
        </div>
        <div className={"col-lg-1 col-md-1 "+(collapse[k] === true ? 'rotate-arrow' : 'text-center')}>
          <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
        </div>
        <Collapse isOpen={collapse[k]} 
          className="col-md-12 col-lg-12 mt30">
          {
            key === 'Processes & Policies' && grouped[key] ?
            Object.keys(groupBy(grouped[key].filter(o => o.value && o.value.length > 0),(o) => o.kpi)).map((kpi,i) => {
             const answeredCount = grouped[key].filter(e => e.kpi === kpi).length;
              const totalCount = find(questionsProcessAndPolicies,(e => e.kpiId === kpi)).questions.length;
              return(
                <div key={i} className="review-answers mb10">
                  <span style={{fontWeight:600}}>{answeredCount} of {totalCount}
                  </span> questions answered for 
                  <span className="ml5" style={{fontWeight:600}}>{getKpiNameByCode(kpi)}</span>
                </div>
              )
            })
            :
            grouped[key] && grouped[key].filter(o => o.value && o.value.length > 0).map((o,i) => {
              const kpiCode = o.kpi;
              return(
                <div key={i} className="review-answers mb10">
                  <span style={{fontWeight:600}}>1 of 1
                  </span> questions answered for 
                  <span className="ml5" style={{fontWeight:600}}>{getKpiNameByCode(kpiCode)}</span>
                </div>
              )
            })
          }
        </Collapse>
      </div>
      dropdowns.push(dropdown);
    }
    // console.log(dropdowns);
    return dropdowns;
  }

  render() { 
    const {selectedDate, questionsWithAnswer} = this.props;
    // console.log(questionsWithAnswer);
    return ( 
      <div class="mt30">
      <div className="title-text">Manual Data Entry</div>
      <Steps
        steps={manualDataEntrySteps}
        currentStep={(this.props.currentStep - 1)}
      />
      <div className="review-sub-section">
        <Row>
            <Col sm="11" md="11" className="manual-entry-instruction">
              Please review the selections you made before you submit the form.
            </Col>
        </Row>
        <span className="manual-entry-instruction_inputs">
        <Row className="mt20">
          <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
          <div className="review-sub-section"> 
              <span className="review-file-txt">Office: </span>
              <span className="review-file-name">
                {this.props.office}
              </span>
            </div>
            <div className="review-sub-section"> 
              <span className="review-file-txt">Date: </span>
              <span className="review-file-name">
                {selectedDate ? moment(selectedDate).format('MM/DD/YYYY') : ""}
              </span>
            </div>
            {
              this.populateDropdowns()
            }
         </Col>
       </Row>
       </span>
       <ReviewAlert 
       reviewHeading={`These are your final selections.`}
       type={mapType.uploadEmployeeDataCsv}
       message={`Please note the filled out survey sections  are available to all users in your office, and provide visibility to the underlying factors affecting your Diversity and Inclusion scores.`}
        />
        <Actions
        nxtBtnIcon="flaticon-tick" 
        {...this.props} />
      </div>
      </div>
    );
  }
}
 
export default ReviewManualDataEntry;
